<template>
<div class="wrap">
  <modal-base class="login-modal" @clickOverlay="toggleLoginModal({ val: false })" v-if="!registerSuccess">
    <div class="login-modal__body">
      <div class="login-modal__left">
        <div class="login-modal__left-wrap">
          <div class="login-modal__welcome">Welcome!</div>
            <div class="login-modal__google">
              <square-btn
                class="login-google"
                @click="clickOnGoogleBtn"
                :disabled="disabledGoogleBtn"
                @mouseover="iconPlusHoverState = true"
                @mouseleave="iconPlusHoverState = false">
                <icon-base red>
                  <icon-google/>
                </icon-base>
                <icon-base
                  class="icon-plus"
                  :green="iconPlusHoverState">
                  <icon-plus />
                </icon-base>
              </square-btn>
              <div class="login-modal__google_right">
                <div class="login-modal__google-text">Login with</div>
                <div class="login-modal__google-logo"></div>
              </div>
            </div>
          <div class="login-modal__notice">You can easily join by using your social accounts or use the form on the right</div>
        </div>
      </div>
      <div class="login-modal__separate-btn">OR</div>
      <div class="login-modal__right">
        <div class="login-modal__right-wrap">
          <div class="login-modal__tabs-titles">
            <button class="login-modal__tab-title" @click="selectLoginTab" :class="{'login-modal__tab-title_active': selectFirstTab}">Login</button>
            <button class="login-modal__tab-title" @click="selectRegistrationTab" :class="{'login-modal__tab-title_active': registerTabIsActive}">Sign up</button>
            <div class="login-modal__circle" :class="{'login-modal__circle_login': selectFirstTab, 'login-modal__circle_register': registerTabIsActive}"></div>
          </div>
          <div class="login" v-if="selectFirstTab">
            <form novalidate @submit.stop.prevent="tryToSendForgotPasswordForm" class="forgot" v-if="forgotPasswordIsActive">
              <div class="forgot__notice">
                Please enter your email to help us confirm your identity
              </div>
              <input-el
                type="email"
                placeholder="Enter your email"
                label="Email"
                name="forgotPassword"
                inputId="forgot-password"
                @input="serverFieldErrors.forgot.email = null"
                v-model.trim="$v.forgot.email.$model"
                :error="$v.forgot.email.$error"
              />
              <div class="forgot__go-back" @click="selectLoginTab">Go back to login</div>
              <button-el left red large :disabled="requestInProgress">
                Reset password
                <icon-base slot="icon" :red="!requestInProgress" :grey="requestInProgress">
                  <icon-arrow-max />
                </icon-base>
              </button-el>
            </form>
            <form novalidate @submit.stop.prevent="tryToSendLoginForm" v-else-if="loginTabIsActive">
              <input-el
                class="login__input"
                type="email"
                name="loginEmail"
                inputId="login__email"
                placeholder="Enter your email"
                label="Email"
                @input="serverFieldErrors.login.email = null"
                v-model.trim="$v.login.email.$model"
                :error="$v.login.email.$error"
              />
              <input-el
                type="password"
                name="loginPassword"
                inputId="login__password"
                placeholder="Enter your password"
                label="Password"
                @input="serverFieldErrors.login.password = null"
                v-model="$v.login.password.$model"
                :error="$v.login.password.$error"
              />
              <div class="forgot-password" @click="selectForgotTab">Forgot password?</div>
              <checkbox-el name="rememberMe" id="login__checkbox" class="login__checkbox" v-model="login.rememberMe" required>Remember me</checkbox-el>
              <button-el :disabled="requestInProgress" left red large class="login__btn">
                Sign In
                <icon-base slot="icon" :red="!requestInProgress" :grey="requestInProgress">
                  <icon-arrow-max />
                </icon-base>
              </button-el>
            </form>
          </div>
          <div class="register" v-else-if="registerTabIsActive">
            <form novalidate @submit.stop.prevent="tryToSendRegisterForm">
              <input-el
                type="email"
                label="Email"
                name="registerEmail"
                inputId="register__email"
                placeholder="Enter your email"
                class="register__input"
                @input="serverFieldErrors.register.email = null"
                v-model.trim="$v.register.email.$model"
                :error="$v.register.email.$error"
              />
              <input-el
                type="password"
                label="Password"
                name="registerPassword"
                inputId="register__password"
                placeholder="Enter your password"
                class="register__input"
                @input="serverFieldErrors.register.password = null"
                v-model.trim="$v.register.password.$model"
                :error="$v.register.password.$error"
              />
              <input-el
                type="password"
                label="Repeat password"
                name="registerPasswordRepeat"
                inputId="register__password_repeat"
                placeholder="Repeat your password"
                class="register__input"
                @input="serverFieldErrors.register.confirmPassword = null"
                v-model="$v.register.confirmPassword.$model"
                :error="$v.register.confirmPassword.$error"
              />
              <checkbox-el name="acceptRules" id="register__checkbox" class="register__checkbox" v-model="register.acceptTermsOfUse" required>I accept <router-link to="/terms-of-use" target="_blank">Terms of Use</router-link></checkbox-el>
                <button-el :disabled="submitIsDisabled" left red large class="register__btn">
                  Sign Up
                <icon-base slot="icon" :red="!submitIsDisabled" :grey="submitIsDisabled">
                  <icon-arrow-max />
                </icon-base>
              </button-el>
            </form>
          </div>
        </div>
      </div>
    </div>
  </modal-base>
  <success-modal
    v-if="registerSuccess"
    :register="showSuccessPopUp"
    :reset="showResetPopUp"
    @onClickOverlay="toggleLoginModal({ val: false })"
  ></success-modal>
</div>
</template>

<script>
import loginModalTabs from 'src/models/LoginModalTabs';
import ModalBase from 'Common/ModalBase';
import checkMobileVersion from 'src/mixins/checkMobileVersion';
import loginModalLogicMixin from './loginModalLogicMixin';

export default {
  mixins: [
    loginModalLogicMixin,
    checkMobileVersion,
  ],
  components: {
    ModalBase,
  },
  methods: {
    selectLoginTab() {
      this.toggleLoginModal({ val: true, activeTab: loginModalTabs.login });
    },
    selectRegistrationTab() {
      this.toggleLoginModal({ val: true, activeTab: loginModalTabs.register });
    },
    selectForgotTab() {
      this.toggleLoginModal({ val: true, activeTab: loginModalTabs.forgot });
    },
  },
  watch: {
    isMobile(val) {
      if (!val) {
        return;
      }
      if (this.selectFirstTab) {
        this.$router.push('/authorization-page/sign-in');
      } else if (this.registerTabIsActive) {
        this.$router.push('/authorization-page/sign-up');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .login-google {
    display: inline-block;
    margin-left: 9px;
    cursor: pointer;
    background: $white-color2;
    width: 70px;
    height: 70px;
    border-radius: 4px;
    box-shadow: 3px 3px 8px $black-color8;
    outline: none;
    border: none;
    &:hover {
      background: $white-color2 !important;
    }
  }
  .login-modal {
    &__body {
      width: 703px;
      background: $white-color2;
    }
    &__google {
      margin-left: 59px;
      margin-top: 111px;
      &_right {
        display: inline-block;
        vertical-align: top;
        margin-left: 27px;
        margin-top: 9px;
      }
    }
    &__google-text {
      @include font(16px, $white-color2);
      margin-bottom: 5px;
    }
    &__google-logo {
      background: url("~src/assets/svg/google.svg");
      width: 89px;
      height: 28px;
    }
    &__separate-btn {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: $white-color2;
      position: absolute;
      line-height: 22px;
      @include font(14px);
      font-weight: 600;
      text-align: center;
      padding: 1.5em 1em;
      top: 50%;
      margin-top: -32px;
      left: 50%;
      margin-left: -46px;
      user-select: none;
    }
    &__welcome {
      @include font(32px, $white-color2);
      font-weight: 500;
      padding: 53px 60px;
    }
    &__notice {
      @include font(13px, $white-color2);
      font-weight: 500;
      line-height: 20px;
      max-width: 218px;
      margin: 126px auto 0;
    }
    &__left {
      @include attachImage('red-pattern', 337px, 572px);
      background-size: cover;
      border-radius: 5px 0 0 5px;
      display: inline-block;
    }
    &__right {
      max-width: 360px;
      display: inline-block;
      vertical-align: top;
      width: 100%;
      padding: 0 50px;
    }
    &__tabs-titles {
      margin: 54px 7px 0;
      position: relative;
    }
    &__tab-title {
      @include font(17px, $black-color1, 500);
      @include removeBtnDefaults;
      text-decoration: none;
      line-height: 27px;
      &:first-child {
        margin-right: 24px;
      }
    }
    &__tab-title_active {
      color: $red-color3;
    }
    form {
      max-width: 245px;
      width: 100%;
      margin-left: 8px;
    }
  }
  .login {
    margin-top: 81px;
    &__input {
      margin-bottom: 30px;
    }
    &__checkbox {
      margin-top: 45px;
    }
    &__btn {
      margin-top: 20px;
    }
    .forgot {
      &__notice {
        @include font(15px, $black-color1);
        line-height: 24px;
        margin-top: 88px;
        margin-bottom: 73px;
      }
      &__go-back {
        cursor: pointer;
        @include font(13px, $red-color3, 500);
        margin-top: 10px;
        margin-bottom: 72px;
      }
    }
  }
  .register {
    margin-top: 31px;
    &__input {
      margin-bottom: 30px;
    }
    &__checkbox {
      margin-top: 40px;
    }
    &__btn {
      margin-top: 20px;
    }
  }
  .forgot-password {
    cursor: pointer;
    text-decoration: none;
    @include font(13px, $red-color3 !important);
    font-weight: 500;
    margin-top: 10px;
    display: block;
  }
  .login-modal__circle {
    top: 0px !important;
    &_login {
      @include activeCircle(50px);

    }
    &_register {
      @include activeCircle(144px);
    }
  }

  .icon-plus {
    position: relative;
    top: -3px;
    left: 3px;
  }
  .icon-google {
    position: relative;
    left: 1px;
    top: 1px;
    transform: scale(1.3);
  }
  </style>


// WEBPACK FOOTER //
// src/components/loginTools/LoginModal.vue